"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var styles = function styles(theme) {
  return {
    root: {
      fontSize: '14px',
      color: '#FFFFFF',
      transition: 'background-color 200ms linear !important',
      animation: 'none !important',
      borderRadius: '6px',
      fontFamily: 'DIN Next LT Pro',
      paddingTop: '7px',
      paddingBottom: '7px',
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    primary: {
      color: '#ffffff',
      backgroundColor: _Theme.colors.primary,
      '&:hover': {
        backgroundColor: _Theme.colors.secondary
      },
      '&:active': {
        backgroundColor: _Theme.colors.tertiary
      },
      '&.Mui-disabled': {
        backgroundColor: _Theme.colors.disabled,
        color: _Theme.colors.disabledText
      }
    },
    appPrimary: {},
    secondary: {
      color: _Theme.colors.secondary,
      backgroundColor: 'transparent',
      borderStyle: 'solid',
      borderColor: _Theme.colors.secondary,
      borderWidth: '1px',
      '&:hover': {
        backgroundColor: 'transparent',
        borderColor: _Theme.colors.primary,
        color: _Theme.colors.primary
      },
      '&:active': {
        borderColor: _Theme.colors.tertiary,
        color: _Theme.colors.tertiary
      },
      '&.Mui-disabled': {
        backgroundColor: 'transparent',
        borderColor: _Theme.colors.disabled,
        color: _Theme.colors.disabledText
      }
    },
    appSecondary: {
      color: 'white',
      borderColor: 'white'
    },
    tertiary: {
      padding: '0',
      border: 'none',
      backgroundColor: 'transparent',
      color: _Theme.colors.secondary,
      '&:hover': {
        backgroundColor: 'transparent',
        color: _Theme.colors.primary
      },
      '&:active': {
        color: _Theme.colors.tertiary
      },
      '&.Mui-disabled': {
        color: _Theme.colors.disabledText
      }
    },
    disabled: {
      color: 'black'
    },
    app: {
      borderRadius: '12px',
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '25px',
      paddingRight: '25px'
    }
  };
};

var LoadingIndicator = function LoadingIndicator() {
  return /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    size: 20,
    color: "inherit",
    style: {
      marginRight: 4
    }
  });
};

var BaseButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(BaseButton, _PureComponent);

  var _super = _createSuper(BaseButton);

  function BaseButton() {
    _classCallCheck(this, BaseButton);

    return _super.apply(this, arguments);
  }

  _createClass(BaseButton, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          children = _this$props.children,
          icon = _this$props.icon,
          _this$props$color = _this$props.color,
          color = _this$props$color === void 0 ? 'primary' : _this$props$color,
          _this$props$loading = _this$props.loading,
          loading = _this$props$loading === void 0 ? false : _this$props$loading,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? null : _this$props$className,
          classes = _this$props.classes,
          title = _this$props.title,
          startIcon = _this$props.startIcon,
          endIcon = _this$props.endIcon,
          props = _objectWithoutProperties(_this$props, ["children", "icon", "color", "loading", "className", "classes", "title", "startIcon", "endIcon"]);

      if (props.onPress) {
        props.onClick = props.onPress;
        delete props.onPress;
      }

      return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, props, {
        disableRipple: true,
        disableElevation: true,
        variant: "text",
        classes: {
          root: classes.root,
          disabled: classes.disabled
        },
        className: (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, classes.primary, color === 'primary' || color === 'app-primary'), _defineProperty(_classnames, classes.secondary, color === 'secondary' || color === 'app-secondary'), _defineProperty(_classnames, classes.tertiary, color === 'tertiary'), _defineProperty(_classnames, classes.appPrimary, color === 'app-primary'), _defineProperty(_classnames, classes.appSecondary, color === 'app-secondary'), _defineProperty(_classnames, classes.app, color === 'app-primary' || color === 'app-secondary'), _classnames), className),
        startIcon: loading ? /*#__PURE__*/_react["default"].createElement(LoadingIndicator, null) : startIcon || icon
      }), loading && /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
        size: 20,
        color: "inherit",
        style: {
          marginRight: 10
        }
      }), title || children);
    }
  }]);

  return BaseButton;
}(_react.PureComponent);

var Button = (0, _styles.withStyles)(styles)(BaseButton);
exports.Button = Button;